enum AppointmentCancellationReason {
  CUSTOMER_NOT_INTERESTED = 'CUSTOMER_NOT_INTERESTED',
  OTHER = 'OTHER',
  SYSTEM_OUTAGE = 'SYSTEM_OUTAGE',
  SYSTEM_ROLLBACK = 'SYSTEM_ROLLBACK',
}

enum AppointmentRescheduleReason {
  CUSTOMER_NOT_AVAILABLE = 'CUSTOMER_NOT_AVAILABLE',
  OTHER = 'OTHER',
  PROVIDER_ILLNESS = 'PROVIDER_ILLNESS',
  PROVIDER_UNAVAILABLE = 'PROVIDER_UNAVAILABLE',
  WAX_OCCLUSION = 'WAX_OCCLUSION',
}

enum AppointmentType {
  AFTERCARE_FOLLOW_UP = 'AFTERCARE_FOLLOW_UP',
  EXTENDED_FOLLOW_UP = 'EXTENDED_FOLLOW_UP',
  FINAL_APPOINTMENT = 'FINAL_APPOINTMENT',
  FOLLOW_UP = 'FOLLOW_UP',
  HEARING_AID_EVALUATION = 'HEARING_AID_EVALUATION',
  PREP_CALL = 'PREP_CALL',
  VIDEO_CARE_CALL = 'VIDEO_CARE_CALL',
  ENT_APPOINTMENT = 'ENT_APPOINTMENT',
}

enum AppointmentStatus {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  CONFIRMED = 'CONFIRMED',
  DENIED = 'DENIED',
  PENDING = 'PENDING',
  RESCHEDULED = 'RESCHEDULED',
}

enum AppointmentResourceType {
  CABIN = 'CABIN',
  CONSULTANT = 'CONSULTANT',
  FITTER = 'FITTER',
  FITTER_INTERNAL = 'FITTER_INTERNAL',
  VIDEO_CARE_CALL_SPECIALIST = 'VIDEO_CARE_CALL_SPECIALIST',
}

enum Salutation {
  DOCTOR = 'DOCTOR',
  DOCTOR_MEDICAL = 'DOCTOR_MEDICAL',
  MISS = 'MISS',
  MISSES = 'MISSES',
  MISTER = 'MISTER',
  PROFESSOR = 'PROFESSOR',
  PROFESSOR_DOCTOR = 'PROFESSOR_DOCTOR',
  PROFESSOR_DOCTOR_DOCTOR = 'PROFESSOR_DOCTOR_DOCTOR',
}

enum SchedulingMode {
  CONSULTANT = 'consultant',
  FITTER = 'fitter',
}

export {
  AppointmentCancellationReason,
  AppointmentRescheduleReason,
  AppointmentResourceType,
  AppointmentStatus,
  AppointmentType,
  Salutation,
  SchedulingMode,
}
